import { Text } from '@applyboard/crystal-ui'

export function Asterisk() {
  return (
    <Text as="span" aria-hidden intent="negative" variant="labelM" contrast="mid">
      *
    </Text>
  )
}
